var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"label":_vm.$t(_vm.input.label),"prepend-icon":_vm.input.icon,"append-icon":_vm.input.required ? 'mdi-asterisk' : '',"rules":_vm.input.rules ? _vm.input.rules : [],"value":_vm.initial,"hint":_vm.input.hint,"type":_vm.input.type,"outlined":""},on:{"input":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }